import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";
import { Typography } from "@tmca/toyota-kit";

import { QA_ALL_VEHICLES_BUTTON_CATEGORY } from "../../../modules/Data/static";
import QAWrapperTK from "../../../modules/toyota-kit/QAWrapperTK";
import "./VehicleFilter.scss";

export interface IVehicleFilter {
  id: string;
  label: string;
  tags: string[];
}

interface VehicleFilterProps {
  filters: IVehicleFilter[];
  customClassName?: string;
  onFilterChange: (filterId: string) => void;
  selectedFilter?: string;
}

const VehicleFilter = ({
  customClassName = "",
  filters,
  onFilterChange,
  selectedFilter = "",
}: VehicleFilterProps) => {
  const { projectClass, breakpointActive } = useUiContext();

  const getClassName = () =>
    classNames(`${projectClass}_VehicleFilter`, breakpointActive, customClassName);

  const getFilterClassName = (filter: IVehicleFilter) =>
    classNames(`${projectClass}_VehicleFilter__item`, {
      [`${projectClass}_VehicleFilter__item--selected`]:
        filter.id === selectedFilter ||
        (selectedFilter === null && filter.id === firstFilterId),
    });

  const handleFilterClick = (filterId: string) => {
    onFilterChange(filterId);
  };

  const firstFilterId = filters?.length > 0 ? filters[0].id : null;

  return (
    <nav className={getClassName()}>
      {filters?.map((filter) => (
        <QAWrapperTK key={filter.id} id={QA_ALL_VEHICLES_BUTTON_CATEGORY}>
          <Typography
            variant={"plainLink"}
            textColour={
              filter.id === selectedFilter ||
              (selectedFilter === null && filter.id === firstFilterId)
                ? "weaker"
                : "weak"
            }
            className={getFilterClassName(filter)}
            onClick={() => handleFilterClick(filter.id)}
          >
            {filter.label}
          </Typography>
        </QAWrapperTK>
      ))}
    </nav>
  );
};

export default VehicleFilter;
